import { makeStyles } from "@mui/styles"

export const useMenuOverrides = makeStyles(() => ({
  list: { padding: 0 },

  paper: ({ maxHeight, menuGap }) => ({
    border: "1px solid #ebebeb",
    marginTop: menuGap,
    maxHeight,
  }),
}))

export const useIconOverrides = makeStyles(({ palette }) => {
  return {
    filterIcon: {
      "&:after": {
        backgroundColor: palette.common.black,
        borderRadius: "50%",
        content: "''",
        height: "30px",
        left: "7px",
        opacity: "0",
        position: "absolute",
        top: "6px",
        transform: "translate(-50%, -50%) scale(0.1)",
        transition: "all 0.2s",
        width: "30px",
        zIndex: "1",
      },
      "&:hover": {
        "&:after": {
          backgroundColor: palette.grey["200"],
          opacity: "0.4",
          transform: "translate(-50%, -50%) scale(1)",
        },
        color: "#554854",
      },
      color: "#9b9b9b",
      cursor: "pointer",
      fontSize: "14px",
      position: "relative",
      zIndex: "2",
    },
  }
})
